<template>
    <div id="main-image-sub">
        <div id="cruisepagina-header">
            <div class="width100" id="cruiseheaderimages">
                <div
                    v-for="img in cruiseImages"
                    class="cruisepage-header-image"
                    :style="{ backgroundImage: packUrlStyle(img) }"
                    @click="selectPicture(img)"
                    style="border-right: 1px solid #fff;"
                ></div>
            </div>
            <font-awesome-icon
                icon="angle-right"
                class="angle-right"
                @click="scrollRight"
            />
            <font-awesome-icon
                icon="angle-left"
                class="angle-left"
                @click="scrollLeft"
            />
            <div
                v-if="showPicture && selectedPicture"
                class="picframe"
                @click="togglePicture"
            >
                <div><img :src="selectedPicture" /></div>
            </div>
        </div>
        <div v-if="showPicture" class="black" @click="togglePicture"></div>
    </div>
</template>

<script>
export default {
    name: 'HeaderImagesCruise',
    data: function() {
        return {
            selectedPicture: '',
            showPicture: false,
        }
    },
    computed: {
        cruiseImages: function() {
            return this.$store.state.cruise.imgs
        },
        maxScreenWidth: function() {
            //Returns the width of all the images together.
            return (
                this.$store.state.cruise.imgs.length * 600 -
                $('#cruiseheaderimages').width()
            )
        },
    },
    methods: {
        togglePicture: function() {
            this.showPicture = !this.showPicture
        },
        packUrlStyle: function(img) {
            if (img && img.hashurl) {
                return 'url(' + img.hashurl + ')'
            } else if (img && img.url) {
                return 'url(' + img.url + ')'
            }
        },
        packUrlImg: function(img) {
            if (img && img.hashurl) {
                return img.hashurl
            } else if (img && img.url) {
                return img.url
            }
        },
        scrollRight: function() {
            let images = $('#cruiseheaderimages')
            console.log(images.scrollLeft())
            if (images.scrollLeft() >= this.maxScreenWidth) {
                images.animate({ scrollLeft: '-=' + this.maxScreenWidth }, 800)
            } else {
                images.animate({ scrollLeft: '+=600' }, 800)
            }
        },
        scrollLeft: function() {
            let images = $('#cruiseheaderimages')
            if (images.scrollLeft() < 1) {
                images.animate({ scrollLeft: '+=' + this.maxScreenWidth }, 800)
            } else {
                images.animate({ scrollLeft: '-=600' }, 800)
            }
        },
        selectPicture: function(img) {
            this.selectedPicture = this.packUrlImg(img)
            this.showPicture = true
        },
    },
}
</script>

<style scoped lang="scss">
#cruisepagina-header {
    .width100 {
        display: flex;
        position: relative;
        flex-wrap: nowrap;
        overflow-x: auto;
    }
    .cruisepage-header-image {
        float: left;
        flex: 0 0 auto;
        width: 600px;
    }
    .angle-right {
        position: absolute;
        right: 10px;
        margin-top: 85px;
        color: white;
        font-size: 134px;
        z-index: 10;
    }
    .angle-left {
        position: absolute;
        left: 10px;
        margin-top: 85px;
        color: white;
        font-size: 134px;
    }
    .picframe {
        right: 0;
        left: 0;
        bottom: 0;
        top: 20vh;
        position: fixed;
        z-index: 5;
        div {
            position: relative;
            margin: auto;
            max-width: 600px;
            padding: 40px;
            border-radius: 2px;
        }
    }
    img {
        position: relative;
        z-index: 7;
    }
}
</style>
